// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCEBAxcsx1VF-epmc-HT_HH0bnzww19h70",
  authDomain: "fpmpg4-cee1c.firebaseapp.com",
  databaseURL: "https://fpmpg4-cee1c-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "fpmpg4-cee1c",
  storageBucket: "fpmpg4-cee1c.appspot.com",
  messagingSenderId: "526290755387",
  appId: "1:526290755387:web:f77c15fda5f5d50ccca11e",
  measurementId: "G-MZ9SMZBGP0"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const database = getDatabase(app);
const storage = getStorage(app);
const db = getFirestore(app);

export { auth, database, storage, db };